export type CareTask = {
  care_task: 'benefits' | 'medications' | 'appointment';
  care_topic?: string;
};

export function parseCareTask(value: Record<string, unknown> | null | undefined): CareTask | null {
  const task = value?.care_task;
  if (task !== 'benefits' && task !== 'medications' && task !== 'appointment') return null;
  const topic = value?.care_topic;
  if (topic != null && topic !== '' && (typeof topic !== 'string' || topic.length > 120 || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(topic))) return null;
  return { care_task: task, ...(typeof topic === 'string' && topic ? { care_topic: topic } : {}) };
}

export function careTaskLabel(task: CareTask): string {
  return {
    benefits: 'Make an application checklist',
    medications: 'Start my medication list',
    appointment: 'Prepare appointment questions',
  }[task.care_task];
}

export function careTaskPrompt(task: CareTask): string {
  const topic = task.care_topic?.replace(/-/g, ' ');
  switch (task.care_task) {
    case 'benefits':
      return `Help me draft a benefits application checklist${topic ? ` for ${topic}` : ''}. Check the current program requirements and ask what you need to know; don't assume eligibility. Let me review the checklist before saving it.`;
    case 'medications':
      return `Help me prepare a medication list for an appointment${topic ? `. I was reading about ${topic}` : ''}. Ask which medications are actually taken before adding anything to this plan. Include questions about any details I still need to confirm.`;
    case 'appointment':
      return `Help me prepare questions for an appointment${topic ? ` about ${topic}` : ''}. Ask what I want to cover; don't assume a diagnosis from the topic I looked up. Let me review the questions before saving them.`;
  }
}
